import { motion } from "framer-motion";

export const DatabricksHero = ({
  partnerTitle = "Databricks Partner · Consulting & Implementation",
  headingLine1 = "Databricks, done",
  headingLine2 = "right the first time.",
  description = "Senior Databricks consultants design, secure, and launch your platform, with your first business use case planned for production in weeks.",
  cardText = "Build a secure foundation for data engineering, analytics, and AI with an implementation plan shaped around your business priorities.",
  bgImageSrc = "/assets/datab/bg1.png",
}) => {
  return (
    <section className="relative min-h-[560px] lg:h-[630px] w-full overflow-hidden bg-[#020514] flex items-center">
      <div className="absolute inset-0 z-0 pointer-events-none">
        <img
          src={bgImageSrc}
          alt="Databricks consulting and implementation platform"
          className="h-full w-full object-cover object-right lg:object-center"
        />
      </div>

      <div className="w-full relative z-10 max-w-[1440px] lg:px-[80px] px-[20px] mx-auto py-16 flex flex-col lg:flex-row lg:items-end justify-between gap-10">
        <motion.div
          initial={{ opacity: 0, x: -40 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          viewport={{ once: true }}
          className="max-w-[820px]"
        >
          <p className="text-white font-graphik text-[14px] md:text-[16px] font-[500] mb-[25px]">
            {partnerTitle}
          </p>

          <h1 className="text-[38px] lg:text-[55px] font-[600] text-white font-sora leading-[1.08] tracking-[-2%] mb-7">
            {headingLine1} <br className="hidden sm:inline" />
            {headingLine2}
          </h1>

          <p className="text-white font-graphik text-[14px] md:text-[16px] font-[500] leading-[1.6] max-w-[612px]">
            {description}
          </p>
        </motion.div>

      </div>
      {/* <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 0.2, ease: "easeOut" }}
        viewport={{ once: true }}
        className="w-full absolute xl:right-[280px] bottom-[80px] sm:w-auto lg:max-w-[356px] bg-[#FFFFFF0A] backdrop-blur-[20px] border border-[#FFFFFF29] p-6 sm:p-7"
      >
        <p className="text-white font-graphik text-[14px] md:text-[16px] font-[500] leading-[1.6]">
          {cardText}
        </p>
      </motion.div> */}
    </section>
  );
};

export default DatabricksHero;